import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { addTask } from '../../services/connections';
import '../../styles/CreateTaskForm.css';

export default function CreateTaskForm() {
  const [title, setTitle] = useState("");
  const [assignedTo, setAssignedTo] = useState("");
  const [description, setDescription] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [priority, setPriority] = useState("Medium");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // Get today's date in YYYY-MM-DD format for min date validation
  const today = new Date().toISOString().split('T')[0];

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (!title || !assignedTo || !description || !dueDate) {
      setError("Please fill in all required fields.");
      return;
    }

    // Validate that due date is not in the past
    const selectedDate = new Date(dueDate);
    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);

    if (selectedDate < todayDate) {
      setError("Due date cannot be in the past. Please select today or a future date.");
      return;
    }

    setLoading(true);
    try {
      await addTask({ title, assignedTo, description, dueDate, priority });
      navigate("/taskBoard", { state: { newTaskAdded: true, newTaskTitle: title } });
    } catch (err) {
      setError(`Failed to create task: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="create-task-page">
      <div className="create-task-container">
        <h2 className="create-task-title">Create New Task</h2>
        <form onSubmit={handleSubmit} className="create-task-form">
          <div className="form-group">
            <label>Title</label>
            <input
              type="text"
              data-testid="title-input"
              placeholder="Enter task title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Assigned to</label>
            <input
              type="text"
              data-testid="assigned-input"
              placeholder="Enter employee name"
              value={assignedTo}
              onChange={(e) => setAssignedTo(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea
              data-testid="description-input"
              placeholder="Describe the task"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            ></textarea>
          </div>

          <div className="priority-section">
            <label>Priority</label>
            <div className="priority-buttons">
              <button
                type="button"
                className={`priority-btn high ${priority === "High" ? "active" : ""}`}
                onClick={() => setPriority("High")}
              >
                High
              </button>
              <button
                type="button"
                className={`priority-btn medium ${priority === "Medium" ? "active" : ""}`}
                onClick={() => setPriority("Medium")}
              >
                Medium
              </button>
              <button
                type="button"
                className={`priority-btn low ${priority === "Low" ? "active" : ""}`}
                onClick={() => setPriority("Low")}
              >
                Low
              </button>
            </div>
          </div>

          <div className="form-group">
            <label>Due Date</label>
            <input
              type="date"
              data-testid="due-date-input"
              value={dueDate}
              min={today}
              onChange={(e) => setDueDate(e.target.value)}
              placeholder="Select due date"
              required
            />
          </div>

          {error && (
            <div className="error-alert" data-testid="error-msg">
              {error}
            </div>
          )}

          <button type="submit" className="submit-btn" data-testid="submit-btn" disabled={loading}>
            {loading ? 'Creating...' : 'Create Task'}
          </button>
        </form>
      </div>
    </div>
  );
}
